import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { SectionHeading, SectionSubtext, DescriptionText } from '../../../ui/typography/styles';
export const PractitionersWrapper = styled(Box)({
  className: 'homepage',
});

export { SectionHeading, SectionSubtext, DescriptionText };
